import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_p84a4prujf: FaireBrandEntity = {
  token: "b_p84a4prujf",
  type: "brand",
  name: "Kate Lauren",
  avatarUrl: "https://cdn.faire.com/fastly/dfad5c2377391c60e5b329ad76540ec1c266c5b7db7d8f5a3a6a76d2943272ce.png",
  bannerUrl: "https://cdn.faire.com/fastly/7ed37ae9b859dcacafa6134edfb2f4fbfef70bd95079e42ed556a78f38ed1fc2.jpeg",
  logoUrl: "https://cdn.faire.com/fastly/dfad5c2377391c60e5b329ad76540ec1c266c5b7db7d8f5a3a6a76d2943272ce.png",
  heroImageUrl: "https://cdn.faire.com/fastly/7ed37ae9b859dcacafa6134edfb2f4fbfef70bd95079e42ed556a78f38ed1fc2.jpeg",
  location: "Berkeley, CA, USA",
  minimumOrderDollars: 0,
  rating: 5,
  reviewCount: 5,
  isInsider: true,
  description: "A necklace to wear as a reminder of an intention, hope, a dream, a wish. ",
  meta: {
    source: "api",
    importedAt: "2026-10-14T17:08:05.270Z",
    importedBy: "entity-db-cli"
  }
};
